// components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isValidToken } from '../utils/helper';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Replace 'token' with your actual token key

  if (token && isValidToken(token)) {
    return children;
  }

  // Redirect to login if token is invalid or missing
  return <Navigate to="/business/login" />;
};

export default PrivateRoute;
